<div class="btn btn-icon w-100" [ngClass]="toggleBtnClass" data-kt-menu-trigger="{default: 'click', lg: 'hover'}" data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
	<ng-container *ngIf="mode$ | async as mode">
		<ng-container *ngIf="mode === 'dark'">
			<span class="text-gray-600 fs-9 px-3 py-2" translate>dark_mode_header_navbar</span>
			<app-keenicon name="moon" class="fs-2 fs-lg-1 theme-light-hide" [ngClass]="toggleBtnIconClass"></app-keenicon>
		</ng-container>
		<ng-container *ngIf="mode === 'light'">
			<span class="text-gray-600 fs-9 px-3 py-2" translate>light_mode_header_navbar</span>
			<app-keenicon name="night-day" class="fs-2 fs-lg-1 theme-dark-hide" [ngClass]="toggleBtnIconClass"></app-keenicon>
		</ng-container>
	</ng-container>
</div>

<div class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-title-gray-700 menu-icon-muted menu-active-bg menu-state-primary fw-semibold py-4 fs-base w-175px" data-kt-menu="true">
	<ng-container *ngIf="menuMode$ | async as menuMode">
		<div class="menu-item px-3 my-0">
			<a class="menu-link px-3 py-2" [ngClass]="{ active: menuMode === 'light' }" (click)="switchMode('light')" tabindex="0" (keydown.enter)="switchMode('light')">
				<span class="menu-icon" data-kt-element="icon">
					<app-keenicon name="night-day" class="fs-3"></app-keenicon>
				</span>
				<span class="menu-title" translate>light_mode_header_navbar</span>
			</a>
		</div>
		<div class="menu-item px-3 my-0">
			<a class="menu-link px-3 py-2" [ngClass]="{ active: menuMode === 'dark' }" (click)="switchMode('dark')" tabindex="0" (keydown.enter)="switchMode('dark')">
				<span class="menu-icon" data-kt-element="icon">
					<app-keenicon name="moon" class="fs-3"></app-keenicon>
				</span>
				<span class="menu-title" translate>dark_mode_header_navbar</span>
			</a>
		</div>
		<div class="menu-item px-3 my-0">
			<a class="menu-link px-3 py-2" [ngClass]="{ active: menuMode === 'system' }" (click)="switchMode('system')" tabindex="0" (keydown.enter)="switchMode('system')">
				<span class="menu-icon" data-kt-element="icon">
					<app-keenicon name="screen" class="fs-3"></app-keenicon>
				</span>
				<span class="menu-title" translate>system_mode_header_navbar</span>
			</a>
		</div>
	</ng-container>
</div>
